import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { Intl } from "../../../state/helpers/IntlProps"
import { ConfigurationRainforest } from "../../../state/integration/IntegrationConfiguration"

type OwnProps = {
    integrationConfigurationId: string,
    configuration: ConfigurationRainforest,
    intl: Intl,
}

const RainforestFormComponent = (props: OwnProps) => {
    if (!props.integrationConfigurationId) {
        return <></>
    }

    return <div className="col-12 ui-module">
        <div className="form-group row">
            <label className="col-3 col-form-label text-align-right" htmlFor="accountId">
                <FormattedMessage
                    id="integration.form.edit.rainforest.account_id"
                    defaultMessage="Merchant ID"
                />
            </label>
            <div className="col-9">
                <input
                    name="accountId"
                    value={props.configuration.accountId}
                    disabled={true}
                    id="accountId"
                    type="text"
                    className="form-control"
                />
            </div>
        </div>
    </div>
}

export default injectIntl(RainforestFormComponent)


// WEBPACK FOOTER //
// ./src/integration/form/rainforest/RainforestFormComponent.tsx